<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="新增协议"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 style="width: 40%;margin: 20px auto 0 auto;" autocomplete="off">
            <el-form-item label="协议名称" prop="protocol_name">
                <el-input type="text" v-model="ruleForm.protocol_name" placeholder="请输入协议名称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="前端" prop="role">
                <el-select v-model="ruleForm.role" placeholder="请选择前端"
                           style="width: 100%;" popper-class="yy">
                    <el-option
                        v-for="item in allRole"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="协议文件" :label-width="formLabelWidth" prop="file">
                <el-upload ref="upload" class="upload-demo" accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG,.pdf,.PDF"
                           :action="upload_agreement_path" :file-list="fileList"
                           :on-success="handleSuccess" :before-upload="beforeAvatarUpload" list-type="picture"
                           :multiple="true" :limit="9">
                    <div slot="file" slot-scope="{file}">
                        <pdf class="el-upload-list__item-thumbnail"  v-if="file.name.endsWith('.pdf')" :src="file.url"></pdf>
                        <img v-else class="el-upload-list__item-thumbnail" :src="file.url" alt=""/>
                        <a class="el-upload-list__item-name"><i class="el-icon-document"></i>{{ file.name }}</a>
                        <label class="el-upload-list__item-status-label">
                            <i class="el-icon-upload-success el-icon-check"></i>
                        </label>
                        <i class="el-icon-close" @click="handleRemove(file)"></i>
                        <i class="el-icon-close-tip">按 delete 键可删除</i>
                    </div>

                    <el-button class="upload_btn" size="small" type="primary" v-if="addFileList.length < 9">点击上传
                    </el-button>
                    <div slot="tip" class="el-upload__tip" v-if="addFileList.length < 9">注：请上传小于5M的图片，格式支持PNG,JPG,PDF
                    </div>
                </el-upload>

                <div class="upload-demo">
                    <el-button class="file_view" size="small" type="primary"
                               @click="oneReservationDetail({contract_file: JSON.stringify(addFileList)})">预览协议
                    </el-button>
                </div>

            </el-form-item>

            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
        <el-dialog title="协议详情" :visible.sync="dialogContractFormVisible">
            <el-carousel indicator-position="outside" height="500px" :autoplay="false">
                <el-carousel-item v-for="url in allContractUrls" :key="url">
                    <div class="image_box">
                        <pdf :src="url" v-if="getFileType(url) == 'pdf'"></pdf>
                        <el-image :src="url" v-else></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import pdf from 'vue-pdf'
import {fileType} from "@/api/order";

export default {
    mounted() {
    },
    components: {
        pdf
    },
    data() {
        return {
            allRole: [
                {
                    id: 1,
                    name: '客户端'
                },
                {
                    id: 3,
                    name: '专家端'
                }
            ],
            dialogContractFormVisible: false,
            fileList: [],
            addFileList: [],
            allContractUrls: [],
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            upload_agreement_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=99',
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            ruleForm: {
                file: "",
                protocol_name: "",
                sort: "",
                status: 1,
                content: "",
            },
            rules: {
                protocol_name: [
                    {required: true, message: "请输入协议名称", trigger: "blur"},
                ],
                role: [
                    {required: true, message: "请选择前端", trigger: "blur"},
                ],
                content: [
                    {required: true, message: "请填写协议内容", trigger: "blur"},
                ],
                file: [{
                    required: true,
                    message: "请上传协议",
                    trigger: "blur"
                },],
            },
            formLabelWidth: '120px',
        };
    },
    methods: {
        getFileType(url) {
            return fileType(url)
        },
        // 返回上一页
        goBack() {
            window.history.go(-1);
        },

        // 提交表单
        submitForm(formName) {
            this.$refs[formName].validate(valid => {

                if (valid) {
                    let params = {
                        'servername': 'Ruyi_ContentServices',
                        'method': 'saveProtocol',
                        'params': {
                            protocol_name: this.ruleForm.protocol_name,
                            role: this.ruleForm.role,
                            content: this.ruleForm.content,
                            protocol_file: this.addFileList,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '创建成功',
                            duration: 1500,
                            onClose: function () {
                                window.history.go(-1);
                            }
                        });
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    return false;
                }
            });
        },
        // 编辑器相关函数
        onEditorReady(editor) {

        },

        // 富文本失去焦点事件
        onEditorBlur() {

        },

        // 富文本获得焦点事件
        onEditorFocus() {

        },

        // 富文本内容改变事件
        onEditorChange(changeData) {

        },

        // 富文本插入图片成功
        uploadSuccess(res, file) {
            let quill = this.$refs.myQuillEditor.quill;
            // 如果上传成功
            if (res.code == '0') {
                // 获取光标所在位置
                let length = quill.getSelection().index;
                // 插入图片  res.url为服务器返回的图片地址
                quill.insertEmbed(length, "image", env.IMG_COMMON_URL_PREFIX + res.data);
                // 调整光标到最后
                quill.setSelection(length + 1);
            } else {
                this.$message.error("图片插入失败");
            }
        },

        // 富文本插入图片报错
        uploadError() {
            this.$message.error("图片插入失败");
        },

        // 富文本图片上传前
        beforeUpload() {

        },

        // 除去图片
        handleRemove(file) {
            this.$refs.upload.handleRemove(file)
            for (let i=0;i<this.addFileList.length; i++) {
                if (file.response.data.file == this.addFileList[i].file) {
                    this.addFileList.splice(i, 1);
                }
            }
        },

        // 上传图片成功
        handleSuccess(response, file, fileList) {
            let addFileList = [];
            let imageUrl = this.imgUrl;
            for (let i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        let obj = {
                            file: name,
                            x: fileList[i].x,
                            y: fileList[i].y,
                        };
                        addFileList.push(obj);
                    }
                }
            }
            this.addFileList = addFileList;
            this.ruleForm.file = "file";
        },
        //上传图片之前，检测文件格式
        beforeAvatarUpload(file) {
            if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('图片只能是jpg/png/pdf格式!');
            }
            if (!isLt5M) {
                isJPG = false;
                this.$message.error('图片大小不能超过5MB!');

            }
            return isJPG;
        },
        // 协议详情-预览
        oneReservationDetail(data) {
            this.allContractUrls = [];
            var allContractUrls = [];
            if (data.contract_file) {
                var contract_file = JSON.parse(data.contract_file);
                if (contract_file.length > 0) {
                    for (var i = 0; i < contract_file.length; i++) {
                        var url = this.imgUrl + contract_file[i].file;
                        allContractUrls.push(url);
                    }
                }
            }
            this.allContractUrls = allContractUrls;
            this.dialogContractFormVisible = true;
        },
    }

};
</script>
<style lang="scss">

.yy {
    z-index: 15000 !important;
}

.image_box {
    height: 500px;
    overflow: hidden;
    overflow-y: auto;

    image {
        width: 100%;
    }
}

.upload_btn {
    position: absolute;
    top: 0;
    left: 30px;
}

.file_view {
    position: absolute;
    top: 0;
    left: 130px;
}
</style>
